import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import cardImagesStyles from "assets/jss/material-dashboard-react/cardImagesStyles.jsx";
import { primaryColor } from "assets/jss/material-dashboard-react.jsx";

import Grid from "@material-ui/core/Grid";
import GridItem from "components/Grid/GridItem.jsx";
// import GridContainer from "components/Grid/GridContainer.jsx";

// core components
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import Faan from "assets/img/faan_logo.png";
import { Link } from "react-router-dom";
// import {appConstants} from "../../../_constants";
import Passengers from "@material-ui/icons/AirlineSeatReclineNormal";
import { connect } from "react-redux";
import withMobileDialog from "@material-ui/core/withMobileDialog";
import { commonActions } from "../../../_actions";
import Authorization from "../component/Authorization";
import { appHelpers } from "../../../_helpers/app.helpers";

const styles = (theme) => ({
  ...cardImagesStyles,
  textWhite: {
    // boxShadow:'0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12)',
    borderRadius: "4px",
    "&, & *": {
      color: "#FFF",
    },
  },
  space: {
    padding: "20px",
    color: "black",
  },
  title: {
    fontWeight: "500",
    fontFamily: "'Montserrat', sans-serif !important",
    color: "black",
    textTransform: "uppercase",
    fontSize: "40px",
    width: "100%",
    // padding:"15px 0"
  },
  cardTitle: {
    fontWeight: "500",
  },
  root: {
    flexGrow: 1,
    width: "100%",
    height: "100vh",
    position: "absolute",
    bottom: 0,
    background: "url('img/airportabj.jpg')",
    //background:"white",
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    overflowY: "hidden",
  },
  rootOverlay: {
    flexGrow: 1,
    background: "rgba(0,0,0,.75)",
    width: "100%",
    position: "absolute",
    bottom: 0,
    top: 0,
    height: "100%",
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  center: {
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100%",
  },
  center2: {
    paddingTop: ".8rem",
    justifyContent: "center",
    // alignItems:'center',
    textAlign: "center",
    width: "100%",
    // marginBottom:"50px"
  },
  card: {
    padding: "1rem 3rem",
    width: "100%",
  },
  checked: {
    color: primaryColor + "!important",
  },
  checkedIcon: {
    width: "20px",
    height: "20px",
    border: "1px solid rgba(0, 0, 0, .54)",
    borderRadius: "3px",
  },
  uncheckedIcon: {
    width: "0px",
    height: "0px",
    padding: "10px",
    border: "1px solid rgba(0, 0, 0, .54)",
    borderRadius: "3px",
  },
  radio: {
    color: primaryColor + "!important",
  },
  radioChecked: {
    width: "20px",
    height: "20px",
    border: "1px solid " + primaryColor,
    borderRadius: "50%",
  },
  radioUnchecked: {
    width: "0px",
    height: "0px",
    padding: "10px",
    border: "1px solid rgba(0, 0, 0, .54)",
    borderRadius: "50%",
  },
  icon: {
    color: "#fff",
  },
});

class MainLanding extends Component {
  constructor(props) {
    super(props);
    this.state = {
      setView: true,
    };
  }

  selectView = (view) => {
    const { dispatch, user } = this.props;
    let currentViewObj;
    dispatch(commonActions.setView(view));
    if (view === "regional") {
      currentViewObj = appHelpers.filterObjFromArray(
        user.ClientApps,
        "Application",
        "PSC Regional"
      );
    } else if (view === "domestic") {
      currentViewObj = appHelpers.filterObjFromArray(
        user.ClientApps,
        "Application",
        "PSC Web"
      );
    }
    currentViewObj.AirlineCode = user.AirlineCode;
    currentViewObj.AirportCode = user.AirportCode;
    dispatch(commonActions.viewData(currentViewObj));
    user.AppRole = appHelpers.interpretRole(currentViewObj);
  };

  render() {
    const { classes, landingDisplay } = this.props;
    // const props_ = {
    //     styles: styles,
    //     user: user,
    //     classes: classes
    // };
    return (
      <div className={`root ${classes.root} `}>
        <div className={classes.rootOverlay}>
          <Authorization {...this.props} />
          <Grid className={classes.center2}>
            <Grid item lg={12} sm={12}>
              <div style={{ margin: "15px 0 20px" }}>
                <img src={Faan} alt={"logo"} />
              </div>
            </Grid>
          </Grid>
          {landingDisplay === "dual view" && (
            <Grid
              container
              className={classes.center}
              style={{ paddingTop: "0", textAlign: "center" }}
            >
              <GridItem container lg={10} sm={12}>
                <Grid container>
                  <Grid item lg={6} sm={12} className={classes.card}>
                    <Grid direction="row" justify="center" alignItems="center">
                      <Card chart onClick={() => this.selectView("regional")}>
                        <Link
                          to="/landing"
                          className={"animate-card-container"}
                        >
                          <CardHeader
                            color="regional"
                            className={"animate-card-header"}
                          >
                            <div style={{ textAlign: "center", margin: "0" }}>
                              <Passengers style={{ fontSize: "60px" }} />
                            </div>
                            <h4 style={styles.title}>
                              PSC International & West coast
                            </h4>
                          </CardHeader>
                          <CardBody>
                            <p style={{ color: "#000" }}>
                              PSC International & West coast Data
                            </p>
                            <Button type="button" color="regional">
                              Explore
                            </Button>
                          </CardBody>
                        </Link>
                      </Card>
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    lg={6}
                    sm={12}
                    className={`${classes.card} ${classes.center}`}
                  >
                    <Grid direction="row" justify="center" alignItems="center">
                      <Card chart onClick={() => this.selectView("domestic")}>
                        <Link
                          to="/landing"
                          className={"animate-card-container"}
                        >
                          <CardHeader
                            color="success"
                            className={"animate-card-header"}
                          >
                            <div style={{ textAlign: "center", margin: "0" }}>
                              <Passengers style={{ fontSize: "60px" }} />
                            </div>
                            <h4 style={styles.title}>PSC Domestic</h4>
                          </CardHeader>
                          <CardBody>
                            <p style={{ color: "#000" }}>PSC Domestic Data</p>
                            <Button type="button" color="primary">
                              Explore
                            </Button>
                          </CardBody>
                        </Link>
                      </Card>
                    </Grid>
                  </Grid>
                </Grid>
              </GridItem>
            </Grid>
          )}

          {landingDisplay === "PSC Regional" && (
            <Grid
              container
              className={classes.center2}
              style={{ paddingTop: "0", textAlign: "center" }}
            >
              <Grid item lg={4} sm={12} className={classes.card}>
                <Grid direction="row" justify="center" alignItems="center">
                  <Card chart onClick={() => this.selectView("regional")}>
                    <Link to="/landing" className={"animate-card-container"}>
                      <CardHeader
                        color="regional"
                        className={"animate-card-header"}
                      >
                        <div style={{ textAlign: "center", margin: "0" }}>
                          <Passengers style={{ fontSize: "60px" }} />
                        </div>
                        <h4 style={styles.title}>PSC Regional</h4>
                      </CardHeader>
                      <CardBody>
                        <p style={{ color: "#000" }}>PSC International & West coast</p>
                        <Button type="button" color="regional">
                          Explore
                        </Button>
                      </CardBody>
                    </Link>
                  </Card>
                </Grid>
              </Grid>
            </Grid>
          )}

          {landingDisplay === "PSC Web" && (
            <Grid
              container
              className={classes.center2}
              style={{ paddingTop: "0", textAlign: "center" }}
            >
              <Grid
                item
                lg={4}
                sm={12}
                className={`${classes.card} ${classes.center}`}
              >
                <Grid direction="row" justify="center" alignItems="center">
                  <Card chart onClick={() => this.selectView("domestic")}>
                    <Link to="/landing" className={"animate-card-container"}>
                      <CardHeader
                        color="success"
                        className={"animate-card-header"}
                      >
                        <div style={{ textAlign: "center", margin: "0" }}>
                          <Passengers style={{ fontSize: "60px" }} />
                        </div>
                        <h4 style={styles.title}>PSC Domestic</h4>
                      </CardHeader>
                      <CardBody>
                        <p style={{ color: "#000" }}>PSC Domestic Data</p>
                        <Button type="button" color="primary">
                          Explore
                        </Button>
                      </CardBody>
                    </Link>
                  </Card>
                </Grid>
              </Grid>
            </Grid>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  const { user, setView, landingDisplay } = state;
  return {
    user,
    setView,
    landingDisplay,
  };
}
export default connect(mapStateToProps)(
  withMobileDialog()(withStyles(styles)(MainLanding))
);



// WEBPACK FOOTER //
// ./src/layouts/Landing/RegionalLanding/landing.jsx